import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'SAEWEB - Dashboard',
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/DashboardPage.vue'),
    meta: {
      isLegacy: true,
      permissions: [eTipoPermissao.FERRAMENTAS_DASHBOARD_MENU_2500600100],
    },
    goesToMenu: true,
  },
]

